import {outter_post} from 'common/js/axios-helper';
import {TatBankProfitApi} from "./constant/UrlMapper";

const host = "8089";
/**
 * 办信用卡管理--机构办卡费率管理接口服务
 * @param data
 * @returns {*}
 */

const add = (data) => {
    return outter_post(TatBankProfitApi.Add, data, host);
};

const list = (data) => {
    return outter_post(TatBankProfitApi.List, data, host);
};


const detail = (data) => {
    return outter_post(TatBankProfitApi.Detail, data, host);
};
const check = (data) => {
    return outter_post(TatBankProfitApi.Check, data, host);
};

const computeProfit = (data) => {
    return outter_post(TatBankProfitApi.ComputeProfit, data, host);
};


export default {add, list, detail, check, computeProfit}




// WEBPACK FOOTER //
// ./src/service/TatBankProfitService.js